import { FC, Fragment, useEffect, useState } from 'react';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getBlobUrl, getDefaultCityGalleryImage, resolveGalleryImageUrl } from 'utils/shared/tripBuilderImages';
import TripBuilderHotelImageModal from './TripBuilderHotelImageModal';
import { getProposalGallery } from 'services/proposal';
interface TripBuilderHotelImageProps {
  imageUrl?: string;
  city?: string;
  onImageUrlChange: (url: string | undefined) => void;
  disabled?: boolean;
  uploadLabel?: string;
  changeLabel?: string;
  className?: string;
  modalTitle?: string;
}

const TripBuilderHotelImage: FC<TripBuilderHotelImageProps> = ({
  imageUrl,
  city,
  onImageUrlChange,
  disabled,
  uploadLabel = 'Upload image',
  changeLabel = 'Change Image',
  className,
  modalTitle,
}) => {
  const blobUrl = getBlobUrl();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (imageUrl || !city || disabled) {
      return;
    }

    void getProposalGallery().then((response) => {
      if (!response || response.hasErrors) {
        return;
      }
      const defaultUrl = getDefaultCityGalleryImage(city);
      if (defaultUrl) {
        onImageUrlChange(defaultUrl);
      }
    });
  }, [city, imageUrl, disabled, onImageUrlChange]);

  const openModal = () => {
    if (!disabled) {
      setShowModal(true);
    }
  };

  return (
    <Fragment>
      <div className={['pr-tb-image', className].filter(Boolean).join(' ')}>
        {imageUrl ? (
          <div className="pr-tb-image-preview-wrap">
            <button
              type="button"
              className="pr-tb-image-preview"
              onClick={openModal}
              disabled={disabled}
            >
              <img src={resolveGalleryImageUrl(blobUrl, imageUrl)} alt="" />
              <span className="pr-tb-image-preview-overlay text-xxs text-bold flex-center">{changeLabel}</span>
            </button>
            <button
              type="button"
              className="pr-tb-image-remove text-xxs flex-center"
              disabled={disabled}
              onClick={(event) => {
                event.stopPropagation();
                onImageUrlChange(undefined);
              }}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
        ) : (
          <button
            type="button"
            className="btn btn-link btn-sm pr-tb-image-upload flex-center"
            onClick={openModal}
            disabled={disabled}
          >
            {uploadLabel}
          </button>
        )}
      </div>

      {showModal && (
        <TripBuilderHotelImageModal
          isOpen={showModal}
          blobUrl={blobUrl}
          city={city}
          imageUrl={imageUrl}
          title={modalTitle}
          onClose={() => setShowModal(false)}
          onSave={onImageUrlChange}
        />
      )}
    </Fragment>
  );
};

export default TripBuilderHotelImage;
